import { Outlet } from "react-router-dom";

/**
 * GameLayout - Minimal chrome layout for active gameplay.
 *
 * Features:
 * - No bottom navigation (distractions minimized)
 * - Full-screen experience for challenges
 * - Back button is handled within individual challenge screens
 */
export function GameLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-sunshine-100 via-cloud to-sky-100 flex flex-col">
      {/* Full-screen game content */}
      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}

export default GameLayout;
